import { formatNumber } from 'app/common/presentation/format'
import { ArroDownIcon, ArrowUpIcon, NeutralIcon } from 'app/common/presentation/icons'

import styles from './PercentageIndicator.module.scss'

interface PercentageIndicatorProps {
  percentage: number
}

const renderArrowIcon = (percentage: number) => {
  if (percentage > 0) {
    return <ArrowUpIcon />
  } else if (percentage < 0) {
    return <ArroDownIcon />
  } else {
    return <NeutralIcon />
  }
}

const PercentageIndicator = ({ percentage }: PercentageIndicatorProps) => (
  <div className={styles.percentageIndicator}>
    <div
      className={styles.icon}
      {...{ type: percentage > 0 ? 'up' : percentage < 0 ? 'down' : 'neutral' }}
    >
      {renderArrowIcon(percentage)}
    </div>
    <div className={styles.percentage}>{formatNumber(percentage, 'percent')}</div>
  </div>
)

export default PercentageIndicator
